import { Env } from "./types/types";

function getEnv(): Env {
  return {
    API_SERVER_URL: process.env.REACT_APP_FAN1_API_SERVER_URL!,
    AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN!,
    AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID!,
    AUTH0_CLIENT_SECRET: process.env.REACT_APP_AUTH0_CLIENT_SECRET!,
    AUTH0_CALLBACK_URL: process.env.REACT_APP_AUTH0_CALLBACK_URL!,
    AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE!,
    AUTH0_SCOPE: process.env.REACT_APP_AUTH0_SCOPE!,
    STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!,
    TWITTER_CODE_VERIFIER: process.env.REACT_APP_TWITTER_CODE_VERIFIER!,
    TWITTER_CLIENT_ID: process.env.REACT_APP_TWITTER_CLIENT_ID!,
    TWITTER_REDIRECT_URI: process.env.REACT_APP_TWITTER_REDIRECT_URI!,
  };
}

// Export the environment variables
const env = getEnv();
export default env;
